import script from "./FormSelectField.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormSelectField.vue?vue&type=script&lang=ts&setup=true"

import "./FormSelectField.vue?vue&type=style&index=0&id=55801656&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55801656"]])

export default __exports__